import Generator from '../../../Generator'
import Types from '../../../../actions/Types'

export default Generator.node({
  baseType: Types.LOCATIONS,
  nodeType: Generator.NODETYPE.REORDER
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/locations/reorder.js